module.exports = __webpack_public_path__ + "static/media/Lastbg.227410b0.png";